<!-- Footer -->
<div class="footer-basic">
  <footer>
    <div class="social">
      <a target="_blank" href="https://www.instagram.com/arpitmalaiya/"
        ><i class="icon ion-social-instagram"></i></a
      ><a target="_blank" href="https://www.linkedin.com/in/arpit-m-655b588b/"
        ><i class="icon ion-social-linkedin"></i></a
      ><a target="_blank" href="https://github.com/arpitmalaiya"
        ><i class="icon ion-social-github"></i
      ></a>
    </div>
    <!-- <ul class="list-inline">
      <li class="list-inline-item"><a href="#">Home</a></li>,
      <li class="list-inline-item"><a href="#">Services</a></li>
      <li class="list-inline-item"><a href="#">About</a></li>
      <li class="list-inline-item"><a href="#">Terms</a></li>
      <li class="list-inline-item"><a href="#">Privacy Policy</a></li>
    </ul> -->
    <!-- <p class="text-muted text-center copyright">Leave your suggestions here</p> -->
    <p class="copyright">Arpit Malaiya © 2021</p>
  </footer>
</div>
